import computeCanvasScale from '../utils/computeCanvasScale';

export const SET_ORIGINAL_IMAGE = 'SET_ORIGINAL_IMAGE';

const setOriginalImage = (state, payload) => {
  const nextState = {
    ...state,
    feedback: {},
    originalImage: payload.originalImage,
    imgSrc: payload.originalImage.src,
  };

  if (nextState.canvasWidth && nextState.canvasHeight) {
    return {
      ...nextState,
      canvasScale: computeCanvasScale(
        nextState,
        nextState.canvasWidth,
        nextState.canvasHeight,
      ),
    };
  }

  return nextState;
};

export default setOriginalImage;
